import { create } from 'zustand';
import mixpanel from 'mixpanel-browser';
import { MIXPANEL_TOKEN } from '@env';

// Initialize Mixpanel
mixpanel.init(MIXPANEL_TOKEN, {
  persistence: 'localStorage',
  track_pageview: true,
});

interface MixpanelStore {
  isInitialized: boolean;
  track: (event: string, properties?: Record<string, string | number>) => void;
  identifyUser: (userId: string, email?: string) => void;
}

export const useMixpanelStore = create<MixpanelStore>(() => ({
  isInitialized: true,

  track: (event, properties) => {
    mixpanel.track(event, properties);
  },

  identifyUser: (userId, email) => {
    mixpanel.alias(userId); // Merge past anonymous events
    mixpanel.identify(userId); // Identify user

    mixpanel.people.set({
      $email: email,
      sign_up_date: new Date().toISOString(),
    });
  },
}));
